export { TipModal } from './TipModal'
